export default "__VITE_ASSET__DBcDuh6z__"